import { CommonModule } from "@angular/common"
import { Component, OnDestroy, OnInit } from "@angular/core"
import { ToastService } from "src/app/services"
import { Subscription } from "rxjs"
import { TableComponent } from "src/app/components"
import { Column, CommissionApplication } from "src/app/models"
import { ContextService, KngService, LoadingService } from "src/app/services"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
@Component({
    selector: "valben-kng-commission",
    templateUrl: "./kng-commission.page.html",
    styles: [`
        :host {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    `],
    standalone: true,
    imports: [
        MatProgressSpinnerModule,
        CommonModule,
        TableComponent,
    ],
})
export class KngCommissionPage implements OnInit, OnDestroy {
    tableValues: CommissionApplication[] = []
    resultSub: Subscription | undefined = undefined
    refresh = () => {
        this._kngService.GetCommission().subscribe(res => this.tableValues = res)
    }
    loading$ = this._loadingService.kngLoading()
    cols: Column[] = [
        // Not data fields - mat-table needs a unique, non-empty column id, same as the table's own __edit/__history.
        { field: "__approve", header: "Potvrdi", bodyType: "button", buttonFn: (appId) => this.approve(appId), buttonText: "Potvrdi" },
        { field: "__reject", header: "Odbij", bodyType: "button", buttonFn: (appId) => this.reject(appId), buttonText: "Odbij" },
        { field: "oib", header: "OIB", bodyType: "text" },
        { field: "employeeMbrad", header: "Mbrad", bodyType: "text" },
        { field: "fullName", header: "Ime i prezime", bodyType: "text" },
        { field: "totalScore", header: "Broj bodova", bodyType: "number" },
        { field: "superiorScore", header: "Ocjena nadređenog", bodyType: "number" },
        { field: "sectorPc", header: "PC/Sektor", bodyType: "text" },
        { field: "workPlace", header: "Radno mjesto", bodyType: "text" },
        { field: "contractType", header: "Vrsta ugovora", bodyType: "text" },
        { field: "landlordDataPresent", header: "Prijava najmodavca", bodyType: "boolean" },
        { field: "workExperience", header: "Radni staž (godina)", bodyType: "number" },
        { field: "numberOfFamilyMembers", header: "Broj članova uže obitelji", bodyType: "number" },
        { field: "isSingleParent", header: "Samohrani roditelj", bodyType: "boolean" },
        { field: "numberOfChildren", header: "Broj djece u kućanstvu", bodyType: "number" },
        { field: "currentAccomodation", header: "Trenutno stanuje", bodyType: "text" },
        { field: "ownPropertyCloserThan30Km", header: "Članovi uže obitelji i/ili zaposlenik ima nekretninu za stanovanje unutar 30 km", bodyType: "boolean" },
        { field: "ownPropertyFurtherThan30Km", header: "Članovi uže obitelji i/ili zaposlenik ima nekretninu za stanovanje izvan 30 km", bodyType: "boolean" },
        { field: "ownLeaseAgreement", header: "Posjedujem ugovor o najmu", bodyType: "boolean" },
        { field: "addressPropertyInRent", header: "Adresa nekretnine u najmu", bodyType: "text" },
        { field: "workplaceDestination", header: "Destinacija rada", bodyType: "text" },
        { field: "lookingForApartment", header: "U potrazi za stanom", bodyType: "boolean" },
        { field: "monthlyIncomeFamilyMembers", header: "Dohodak članova obitelji", bodyType: "number" },
        { field: "employeeMonthlyIncome", header: "Dohodak djelatnika", bodyType: "number" },
        { field: "totalMonthlyIncome", header: "Ukupni mjesečni dohodak", bodyType: "number" },
        { field: "criteriaMonthlyIncome", header: "Kriteriji: Mjesečni dohodak", bodyType: "number" },
        { field: "criteriaNumberOfChildren", header: "Kriteriji: Broj djece", bodyType: "number" },
        { field: "criteriaPropertyOwnership", header: "Kriteriji: Nekretnine u vlasništvu", bodyType: "number" },
        { field: "criteriaWorkplace", header: "Kriteriji: Radno mjesto", bodyType: "number" },
        { field: "criteriaWorkExperience", header: "Kriteriji: Radni staž", bodyType: "number" },
        { field: "criteriaHousingStatus", header: "Kriteriji: Radnik na smještaju kod poslodavca", bodyType: "number" },
        { field: "criteriaSuperiorEvaluation", header: "Kriteriji: Procjena poslodavca", bodyType: "number" },
    ]

    constructor(
        private _loadingService: LoadingService,
        private _kngService: KngService,
        private _context: ContextService,
        private _messageService: ToastService,
    ) {}

    approve(applicationId: string): void {
        this.tableValues = this.tableValues.filter(a => a.masterId !== applicationId)
        this._context.ApproveApplication(applicationId)
    }

    reject(applicationId: string): void {
        this.tableValues = this.tableValues.filter(a => a.masterId !== applicationId)
        this._context.RejectApplication(applicationId)
    }

    ngOnInit(): void {
        this._kngService.GetCommission().subscribe(res => this.tableValues = res)
        this.resultSub = this._context.getKngResultSubject()?.subscribe(res => {
            if (res !== null) {
                this._messageService.add({
                    severity: res.error ? "error" : "success",
                    summary: res.error ? "Error" : "Success",
                    detail: res.message,
                    life: 10000,
                })
            }
        })
    }

    ngOnDestroy(): void {
        this.resultSub?.unsubscribe()
    }
}
